// extracted by mini-css-extract-plugin
module.exports = {"personal-space-create":"modal_personal-space-create__2Tu0H","selector-container":"modal_selector-container__se5dj"};